<template>
  <div class="con-box">
    <div class="download" @click="download">APP下载</div>
    <div class="pay-content" @click="payContent">付费内容</div>
    <img src="./images/imgbg.png">

    <div class="footer">
      <p class="copyright">
        Copyright © 2015-2024 智慧流版权所有
      </p>
      <div class="beian">
        <span class="msg">
          <a href="https://beian.miit.gov.cn" target="_blank">京ICP备15042556号-1</a>
        </span>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802030160"
          style="text-decoration:none;height:20px;line-height:20px;">
          <img src="./images/beian.png" />
          <p style="height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010802030160号</p>
        </a>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'discoveryPage',

  data() {
    return {

    }
  },
  methods: {
    download() {
      location.href='./download.html'
    },
    payContent() {
      location.href='./pay-content.html'
    }
  },
  created() {

  }
}
</script>
<style lang="less" scoped>
@import "../../assets/css/reset.css";
.con-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  position: relative;
  .download{
    position: absolute;
    right: 0px;
    top: 0px;
    text-align: right;
    padding-top: 20px;
    padding-right: 8%;
    color: white;
    font-size: 18px;
    box-sizing: border-box;
    &:hover{
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .pay-content{
    position: absolute;
    right: 0px;
    top: 0px;
    text-align: right;
    margin-top: 40px;
    padding-top: 20px;
    padding-right: 8%;
    color: white;
    font-size: 16px;
    color: rgb(192, 4, 4);
    box-sizing: border-box;
    &:hover{
      cursor: pointer;
      text-decoration: underline;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
.footer {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    .copyright {
      color: #999;
    }
    .msg {
      color: #999;
      // margin-top: 10px;
      span {
        margin: 0 10px;
      }

      a {
        color: #999;
        margin: 0 10px;
      }
    }
    .beian {
      // width:300px;
      display: flex;
      align-items: center;
      margin: 0 auto;
      padding: 20px 0;
      padding-top: 10px;
      a {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 15px;
        height: 15px;
      }
    }
  }
//   .footer {
//     margin-top: 20px;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     font-size: 12px;
//     .copyright {
//       color: #999;
//     }
//     .msg {
//       color: #999;
//       margin-top: 10px;
//       span {
//         margin: 0 10px;
//       }
//     }
//     .beian {
//       width: 300px;
//       margin: 0 auto;
//       padding: 20px 0;
//       padding-top: 10px;
//       a {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//       }
//       img {
//         width: 15px;
//         height: 15px;
//       }
//     }
//   }
}
</style>
